import { useState, useCallback } from 'react'

const STORAGE_KEY = 'dc_hidden_calendars'

const loadHidden = () => {
  try {
    return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]'))
  } catch {
    return new Set()
  }
}

const saveHidden = (set) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]))
}

export const useCalendarVisibility = () => {
  const [hidden, setHidden] = useState(loadHidden)

  const isVisible = useCallback((calendarId) => !hidden.has(calendarId), [hidden])

  const toggleCalendar = useCallback((calendarId) => {
    setHidden((prev) => {
      const next = new Set(prev)
      if (next.has(calendarId)) {
        next.delete(calendarId)
      } else {
        next.add(calendarId)
      }
      saveHidden(next)
      return next
    })
  }, [])

  return { isVisible, toggleCalendar, hiddenIds: hidden }
}
